var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"id":"Layer_4"}},[_c('path',{attrs:{"d":"M13 25.5C6.1 25.5.5 19.9.5 13S6.1.5 13 .5 25.5 6.1 25.5 13 19.9 25.5 13 25.5zm0-24C6.7 1.5 1.5 6.7 1.5 13S6.7 24.5 13 24.5 24.5 19.3 24.5 13 19.3 1.5 13 1.5z"}}),_c('path',{attrs:{"d":"M21 12.5h-7.5V5h-1v7.5H5v1h7.5V21h1v-7.5H21z"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5612f638","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/components/icons/CircCloseIcon.vue
// module id = tPLi
// module chunks = 4